import AssetLoader from "@/components/AssetLoader/AssetLoader";
import CompareField from "@/components/Form/Fields/CompareField";
import FormFieldValues from "@/components/Form/Fields/FormFieldValues";
import OnChange from "@/components/Form/Helpers/OnChange";
import FormValidators, {
  FV,
} from "@/components/Form/Validation/FormValidators";
import { PDFHighlight } from "@/components/PDFViewer/PDFViewer";
import i18n from "@/i18n";
import { AssetTypes } from "@/model/AssetTypes";
import { Contact } from "@/model/db/Contact";
import BFAssetChooserSelectMultiple from "@/modules/abstract-ui/forms/chooser/BFAssetChooserSelectMultiple";
import CacheService from "@/services/CacheService";
import { hasValue, when } from "@/utils/Helpers";
import MQ from "@/utils/MatchQueryUtils";
import StringUtils from "@/utils/StringUtils";
import classNames from "classnames";
import { FormApi } from "final-form";
import Collapse from "rsuite/esm/Animation/Collapse";
import { Invoice, InvoiceKind } from "../../../RAInterfaces";
import RAInvoiceEntryView from "../../RAInvoiceEntryView";
import RAInvoiceDefaultFields from "./RAInvoiceDefaultFields";
// import "./RAInvoiceDunningFields.scss";

interface RAInvoiceDunningFieldsProps {
  disableAll?: boolean;
  ignoreCompare?: boolean;
  prefix?: string;
  invoice: Invoice;
  form: FormApi;
  onHighlight: (highlight?: PDFHighlight | PDFHighlight[]) => void;

  uploadForm?: boolean;

  invoiceKind: InvoiceKind;
  disableLinkedInvoiceChange?: boolean;
}
const RAInvoiceDunningFields = (props: RAInvoiceDunningFieldsProps) => {
  return (
    <div className={classNames("ra-invoice-dunning-fields")}>
      <CompareField
        ignoreCompare={props.ignoreCompare}
        name={`${props.prefix || ""}linkedInvoice`}
        validate={FV.compose(FV.required())}
      >
        {({ input, meta }) => {
          const renderField = (baseInvoice?: Invoice) => (
            <div className={`__field`}>
              <BFAssetChooserSelectMultiple
                disabled={props.disableLinkedInvoiceChange || props.disableAll}
                detailView={(node: Invoice) => (
                  <div className={`padding-top-10 padding-bottom-10`}>
                    <RAInvoiceEntryView
                      invoice={node}
                      ignoreHistory
                      showInvoiceId
                      simpleView
                      hideCostCenter
                      hideInfoFields
                      hideRelations
                      hideTags
                      dense
                    />
                  </div>
                )}
                assetType={AssetTypes.Invoicing.Invoice}
                {...input}
                label={i18n.t(
                  "ra:RAInvoiceDunningFields.linkedInvoice",
                  "Verknüpfte Rechnung"
                )}
                {...FormValidators.getValidation(meta)}
                getOptionPromise={async (invoice: Invoice) => {
                  const contact = (await CacheService.getData({
                    oType: "asset",
                    id: invoice.data.invoice.contact,
                    assetType: AssetTypes.Contact,
                  })) as Contact;

                  return {
                    label:
                      contact.data.displayName +
                      " - " +
                      StringUtils.formatCurrency(
                        invoice.data.invoice.value.amount,
                        undefined,
                        undefined,
                        invoice.data.invoice.value.currency
                      ),
                    subLabel: invoice.data.invoice.invoiceId,
                    value: invoice._id,
                  };
                }}
                matchQuery={MQ.and(
                  MQ.eq("data.direction", props.invoice.data.direction),
                  MQ.in("data.kind", [InvoiceKind.INVOICE]),
                  MQ.ne("_id", props.invoice._id),
                  MQ.ne("data.status", "init"),
                  when(baseInvoice, (invoice: Invoice) =>
                    MQ.and(
                      MQ.eq(
                        "data.invoice.contact",
                        invoice.data.invoice.contact
                      ),
                      MQ.eq("data.entity", invoice.data.entity)
                    )
                  )
                )}
                onChange={(value) => {
                  props.form.change(
                    `${props.prefix || ""}installmentEntry`,
                    null
                  );
                  input.onChange(value);
                }}
              />
            </div>
          );
          if (!hasValue(input.value)) {
            return renderField();
          }
          return (
            <AssetLoader
              assetType={AssetTypes.Invoicing.Invoice}
              id={input.value[0]}
              render={(invoice: Invoice) => renderField(invoice)}
            />
          );
        }}
      </CompareField>
      {/* <FormFieldValues names={["linkedInvoice"]}>
        {([linkedInvoice]) => (


        )}
        </FormFieldValues> */}

      <FormFieldValues names={[`${props.prefix || ""}linkedInvoice`]}>
        {([linkedInvoice]) =>
          linkedInvoice?.length > 0 ? (
            <>
              <AssetLoader
                assetType={AssetTypes.Invoicing.Invoice}
                id={linkedInvoice[0]}
                render={(invoice: Invoice) => {
                  return (
                    <>
                      <Collapse in={hasValue(linkedInvoice)}>
                        <div>
                          <OnChange
                            ignoreInitialValue
                            value={linkedInvoice}
                            onChange={(linkedInvoice) => {
                              setTimeout(() => {
                                props.form.batch(() => {
                                  props.form.change(
                                    `${props.prefix || ""}contact`,
                                    invoice.data.invoice.contact
                                  );
                                  props.form.change(
                                    `${props.prefix || ""}entity`,
                                    invoice.data.entity
                                  );
                                  props.form.change(
                                    `${props.prefix || ""}objectId`,
                                    invoice.data.objectId
                                  );
                                  props.form.change(
                                    `${props.prefix || ""}activity`,
                                    invoice.data.activity || []
                                  );
                                  props.form.change(
                                    `${props.prefix || ""}invoiceType`,
                                    invoice.data.invoice.invoiceType
                                  );
                                  props.form.change(
                                    `${props.prefix || ""}currency`,
                                    invoice.data.invoice.value.currency
                                  );
                                  // props.form.change(
                                  //   "paymentTypeData.type",
                                  //   invoice.data.invoice.paymentTypeData.type
                                  // );
                                  // props.form.change(
                                  //   "paymentTypeData.iban",
                                  //   (invoice.data.invoice.paymentTypeData as PaymentIBAN).iban
                                  // );
                                  // props.form.change(
                                  //   "paymentTypeData.bic",
                                  //   (
                                  //     invoice.data.invoice
                                  //       .paymentTypeData as PaymentIBANInternational
                                  //   ).bic
                                  // );
                                  // props.form.change(
                                  //   "paymentTypeData.account",
                                  //   (
                                  //     invoice.data.invoice
                                  //       .paymentTypeData as PaymentUSNational
                                  //   ).account
                                  // );
                                  // props.form.change(
                                  //   "paymentTypeData.nameOfBank",
                                  //   (
                                  //     invoice.data.invoice
                                  //       .paymentTypeData as PaymentUSNational
                                  //   ).nameOfBank
                                  // );
                                  // props.form.change(
                                  //   "paymentTypeData.addressOfBank",
                                  //   (
                                  //     invoice.data.invoice
                                  //       .paymentTypeData as PaymentUSNational
                                  //   ).addressOfBank
                                  // );
                                  // props.form.change(
                                  //   "paymentTypeData.routing",
                                  //   (
                                  //     invoice.data.invoice
                                  //       .paymentTypeData as PaymentUSNational
                                  //   ).routing
                                  // );
                                  // props.form.change(
                                  //   "paymentTypeData.swift",
                                  //   (
                                  //     invoice.data.invoice
                                  //       .paymentTypeData as PaymentUSNational
                                  //   ).swift
                                  // );
                                });
                              });
                            }}
                          />
                          <RAInvoiceDefaultFields {...props} />
                        </div>
                      </Collapse>
                    </>
                  );
                }}
              />
            </>
          ) : null
        }
      </FormFieldValues>
    </div>
  );
};

export default RAInvoiceDunningFields;
